import withFeatureBranch from '@wix/da-react-context/pkg/flags/withFeatureBranch';
import AdoptableShopCard from './AdoptableShopCard';
import AdoptableShopCardV2 from './AdoptableShopCard.exclusives_newstyle';

export default withFeatureBranch({
  exclusives_newstyle: AdoptableShopCardV2,
})(AdoptableShopCard);
